import React, {useState, useEffect, Fragment, useRef} from 'react'
import {isNull, isNil, upperFirst, sortedUniq, isArray} from 'lodash';
import {useHistory} from 'react-router-dom';
import { currentLang, accentsTidy } from '../../../utils/functions';
import {siteInfo} from './../../../utils/config';
import { useTranslation } from 'react-i18next';
import W from '../Word';

const DataFilter = ({type, filterFunc, filterType, data}) => {
  const [activeFilter, setActiveFilter] = useState(null);
  const [pageLoad, setPageLoad] = useState(0);
  const [animals, setAnimals] = useState(null);
  const history = useHistory();
  const { t } = useTranslation();
  const searchInputRef = useRef(null);
  const [toggled, setToggled] = useState(false)  
  const animalsFilter = siteInfo[currentLang()]['animal_types'];
  let toggledClass = (toggled) ? "open" : "";

  useEffect(() => {
      setAnimals(checkFilter());
      //console.log(checkFilter());
  }, [data]);
  const selectCategory = value =>{
    //console.log();
    if(!(activeFilter == value)){
      filterFunc({"value": value, "pageNumber": 1});
      var url = "/"+currentLang()+"/";
      if (!isNull(value)) {
        //console.log('test1');
        setActiveFilter(value);

        url += t("menu."+type)+"/";
        history.push(url+t(value));
        
      } else {
          setActiveFilter(null);
          if(['faq', 'recipes'].includes(type)){
              url += t('menu.'+type);
              history.push(url);
          }
          if(['recipes'].includes(type)){
              filterFunc({"value": null, "pageNumber": 1});
          }
      }
    }
  }
 
  const search = str => {
    var searchState = (str.length < 1)? "search_empty" : "search_it";
    filterFunc({"value": null, "pageNumber": 1, "search":accentsTidy(str), "searchState":searchState});
  }
  
  function searchClose(event) {
    event.preventDefault();
    if(toggled){
      document.querySelector('#dataFilterSearch').value = '';
      filterFunc({"value": activeFilter, "pageNumber": 1, "searchState":"search_close"});
    }else{
      filterFunc({"value": activeFilter, "pageNumber": 1, "searchState":"search_empty"});
      
      searchInputRef.current.focus();
      //document.querySelector('#dataFilterSearch').focus();
    }
    setToggled(!toggled)
    
  }

  const checkFilter = () =>{
      if(data){
        var existAnimals = [];
        data.map(item=>{
            if(type == 'faq')
                item.animal_types = item.animal_type;
            if(type == 'breeds')
                item.animal_types = item.animal_type;

            if(!isNil(item.animal_types)){
              if(isArray(item.animal_types)){
                existAnimals = existAnimals.concat(item.animal_types);
                /*if(item.animal_types.includes('game')){
                  console.log(item);
                }*/
              }else{
                existAnimals.push(item.animal_types);
              }
            }else{
              //console.log(item);
            }
        });
        return sortedUniq(existAnimals);
      }
  }
  
  useEffect(() => {
    //console.log(filterType);
      setActiveFilter(filterType);
  }, [filterType])

  useEffect(() => {
      if(!isNil(activeFilter)){
        if(window.innerWidth <= 768 ){
            var activeItem = document.querySelector('.data-filter__item.filter__item.active');
            if(pageLoad == 0){
                if(!isNil(activeItem)){
                  activeItem.scrollIntoView({
                      behavior: "smooth",
                      block: "end",
                      inline: "center",
                      alignToTop: true
                  });
                  setPageLoad(1);
                }

            }else{
                if(!isNil(activeItem)){
                  activeItem.scrollIntoView({
                      behavior: "smooth",
                      inline: "center",
                      alignToTop: true
                  });
                }
            }
        }
      }
  }, [activeFilter])

  // console.log(selectCategory);
  if(animalsFilter.length >= 2 && animals !== null && typeof animals !== 'undefined'){
    if (Object.keys(animals).length >= 2){
      return (
        <div className="row">
          <div className="col-12 col-xxl-6 offset-xxl-3 col-lg-8 offset-lg-2">
            <div className={`data-filter search ${toggledClass}`}>
              <div className="nav_holder">
                <nav>
                  {animals &&
                  <Fragment>
                  <ul className="data-filter__list">
                    {['faq', 'recipes'].includes(type) &&
                      <li className={`data-filter__item filter__item-text ${isNull(activeFilter) ? "active" : ""}`} onClick={()=>{selectCategory(null)}}>
                        <W>{t("datafilter.all"+type)}</W>
                      </li>
                    }
                      {animalsFilter.map(animal=>
                        animals.includes(animal) &&
                          <li className={`data-filter__item filter__item ${(activeFilter === animal) ? "active" : ""}`} onClick={()=>{selectCategory(animal)}}>
                            <i className={'icon-cat-'+ animal}></i> {t("datafilter."+animal)}
                          </li>
                      )}
                  </ul>
                  </Fragment>
                  }
                </nav>
              </div>
              <div className="data-filter__search">
                <div className="action" onClick={searchClose}>
                  <i className="icon-magnify"></i>
                </div>
                <div className="form">
                  <input type="text" id="dataFilterSearch" ref={searchInputRef} placeholder={t("search.placeholder")} onChange={(e)=>{search(e.target.value)}} />
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else {
      return (
        <Fragment>
        </Fragment>
      )
    }
  } else {
    return (
      <Fragment>
      </Fragment>
    )
  }
}

export default DataFilter
